import { OverflowMenu } from 'ui/actionMenu';
import { Delete16, EditNew16 } from 'ui/icons/aurora';
import { AllowedActionMenuElements, ActionMenuOption } from 'ui/actionMenu/types';
import { useModalsContext } from '../contexts';
import { ThirdPartyIntegration } from '../types';

type ThirdPartyActionButtonProps = {
  integration: ThirdPartyIntegration;
};

export const ThirdPartyActionButton = ({ integration }: ThirdPartyActionButtonProps) => {
  const editId = 'edit-third-party-integration';
  const deleteId = 'delete-third-party-integration';

  const { showEditThirdPartyIntegrationModal, showDeleteThirdPartyIntegrationModal } =
    useModalsContext();

  const options: ActionMenuOption[] = [
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <EditNew16 />
          <span>Edit</span>
        </>
      ),
      id: editId,
      onClick: () => showEditThirdPartyIntegrationModal(integration),
    },
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <Delete16 />
          <span>Delete</span>
        </>
      ),
      id: deleteId,
      onClick: () => showDeleteThirdPartyIntegrationModal(integration),
    },
  ];

  return <OverflowMenu id="third-party-table-overflow-menu" options={options} />;
};
